module.exports = [{"type":"title","text":"2024-03-19"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續新增接口：按倉位ID平倉。"},{"type":"html","text":"永續websocket：訂單信息新增stopGuaranteed字段。"},{"type":"html","text":"永續修改接口：查詢訂單接口返回stopGuaranteed字段。"},{"type":"html","text":"永續修改接口：查詢訂單、查詢歷史訂單接口返回triggerOrderId字段。"},{"type":"html","text":"永續行情接口/openApi/swap/v2/quote/contracts新增：tradeMinQuantity、tradeMinUSDT、makerFeeRate、takerFeeRate"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-03-19.json
// module id = j7dp
// module chunks = 3